export const facilityType = [
  { itemValue: 'AIRPORT', itemLabel: 'AIRPORT' },
  { itemValue: 'BALLOONPORT', itemLabel: 'BALLOONPORT' },
  { itemValue: 'SEAPLANE BASE', itemLabel: 'SEAPLANE BASE' },
  { itemValue: 'GLIDERPORT', itemLabel: 'GLIDERPORT' },
  { itemValue: 'HELIPORT', itemLabel: 'HELIPORT' },
  { itemValue: 'ULTRALIGHT', itemLabel: 'ULTRALIGHT' },
];

export const facilityUse = [
  { itemValue: 'PU', itemLabel: 'PUBLIC' },
  { itemValue: 'PR', itemLabel: 'PRIVATE' },
  { itemValue: 'MI', itemLabel: 'MILITARY' },
];

export const facilityStatus = [
  { itemValue: 'O', itemLabel: 'OPEN' },
  { itemValue: 'CI', itemLabel: 'CLOSED INDEFINITELY' },
  { itemValue: 'CP', itemLabel: 'CLOSED PERMANENTLY' },
];

export const coordinatesDeterminationMethod = [
  { itemValue: 'ESTIMATED', itemLabel: 'ESTIMATED' },
  { itemValue: 'SURVEYED', itemLabel: 'SURVEYED' },
];

export const directionFromCity = [
  { itemValue: 'N', itemLabel: 'N' },
  { itemValue: 'NNE', itemLabel: 'NNE' },
  { itemValue: 'NE', itemLabel: 'NE' },
  { itemValue: 'ENE', itemLabel: 'ENE' },
  { itemValue: 'E', itemLabel: 'E' },
  { itemValue: 'ESE', itemLabel: 'ESE' },
  { itemValue: 'SE', itemLabel: 'SE' },
  { itemValue: 'SSE', itemLabel: 'SSE' },
  { itemValue: 'S', itemLabel: 'S' },
  { itemValue: 'SSW', itemLabel: 'SSW' },
  { itemValue: 'SW', itemLabel: 'SW' },
  { itemValue: 'WSW', itemLabel: 'WSW' },
  { itemValue: 'W', itemLabel: 'W' },
  { itemValue: 'WNW', itemLabel: 'WNW' },
  { itemValue: 'NW', itemLabel: 'NW' },
  { itemValue: 'NNW', itemLabel: 'NNW' },
];

export const flightRules = [
  { itemValue: 'VFR/IFR', itemLabel: 'VFR/IFR' },
  { itemValue: 'VFR', itemLabel: 'VFR' },
  { itemValue: 'IFR', itemLabel: 'IFR' },
];

export const utcCodes = [
  { itemValue: '140', itemLabel: 'UTC-12' },
  { itemValue: '-11', itemLabel: 'UTC-11' },
  { itemValue: '105', itemLabel: 'UTC-10' },
  { itemValue: '142', itemLabel: 'UTC-9' },
  { itemValue: '107', itemLabel: 'UTC-9 (-8DT)' },
  { itemValue: '143', itemLabel: 'UTC-8' },
  { itemValue: '108', itemLabel: 'UTC-8 (-7DT)' },
  { itemValue: '21', itemLabel: 'UTC-7' },
  { itemValue: '109', itemLabel: 'UTC-7 (-6DT)' },
  { itemValue: '61', itemLabel: 'UTC-6' },
  { itemValue: '110', itemLabel: 'UTC-6 (-5DT)' },
  { itemValue: '101', itemLabel: 'UTC-5' },
  { itemValue: '111', itemLabel: 'UTC-5 (-4DT)' },
  { itemValue: '103', itemLabel: 'UTC-4' },
  { itemValue: '136', itemLabel: 'UTC-4:30' },
  { itemValue: '145', itemLabel: 'UTC-4 (-3DT)' },
  { itemValue: '102', itemLabel: 'UTC-3' },
  { itemValue: '-2', itemLabel: 'UTC-2' },
  { itemValue: '-1', itemLabel: 'UTC-1' },
  { itemValue: '81', itemLabel: 'UTC-0' },
  { itemValue: '1', itemLabel: 'UTC+1' },
  { itemValue: '2', itemLabel: 'UTC+2' },
  { itemValue: '3', itemLabel: 'UTC+3' },
  { itemValue: '4', itemLabel: 'UTC+4' },
  { itemValue: '5', itemLabel: 'UTC+5' },
  { itemValue: '6', itemLabel: 'UTC+6' },
  { itemValue: '7', itemLabel: 'UTC+7' },
  { itemValue: '8', itemLabel: 'UTC+8' },
  { itemValue: '9', itemLabel: 'UTC+9' },
  { itemValue: '10', itemLabel: 'UTC+10' },
  { itemValue: '11', itemLabel: 'UTC+11' },
  { itemValue: '104', itemLabel: 'UTC+12' },
  { itemValue: '148', itemLabel: 'BRT_T' },
  { itemValue: '129', itemLabel: 'BRA_CT' },
  { itemValue: '130', itemLabel: 'BRA_ET' },
  { itemValue: '112', itemLabel: 'CAN_AT' },
  { itemValue: '137', itemLabel: 'CAN_NW' },
  { itemValue: '146', itemLabel: 'CHI_ST' },
  { itemValue: '127', itemLabel: 'CHL_CT' },
  { itemValue: '124', itemLabel: 'CHL_IS' },
  { itemValue: '123', itemLabel: 'MEX_CT' },
  { itemValue: '122', itemLabel: 'MEX_MT' },
  { itemValue: '121', itemLabel: 'MEX_PT' },
  { itemValue: '126', itemLabel: 'PRY' },
  { itemValue: '161', itemLabel: 'NULL' },
  { itemValue: '149', itemLabel: 'UYT_T' },
  { itemValue: '128', itemLabel: 'URY' },
];
